module.exports = __webpack_public_path__ + "img/fixed-bar.6637a0c4.png";